/* eslint-disable @fullstory/annotate-react/data-component */
import React from 'react';
import { Box } from '../Box';
import { CellAlignment, Column } from './types';

export function useBodyCells<R>(
  Component: React.ComponentType<{ align?: CellAlignment } & any>,
  columns: Column<R>[],
  row: R,
  cellProps: { [key: string]: any },
) {
  return columns.map(column => {
    const { renderCell, key, align, sortable } = column;
    const cell = renderCell(row, column);
    const wrappedCell = (
      <Box paddingRight={24} testId="icon-padding">
        {cell}
      </Box>
    );

    return (
      <Component key={key} align={align} {...cellProps}>
        {sortable && align === 'right' ? wrappedCell : cell}
      </Component>
    );
  });
}
